const Routes = [
  {
    path: '/sales-analysis',
    name: 'salesAnalysis',
    component: () => import('@/app/sales_analysis/TheSalesAnalysis'),
    redirect: '/sales-analysis/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/sales_analysis/views/TheIndex'),
        name: 'index',
        redirect: '/sales-analysis/long-grid/',
        children: [
          {
            path: 'long-grid',
            name: 'long-grid',
            component: () => import('@/app/sales_analysis/components/TheLongGridContent')
          },
          {
            path: 'wide-grid',
            name: 'wide-grid',
            component: () => import('@/app/sales_analysis/components/TheWideGridContent')
          }
        ]
      },
      {
        path: 'dates-granularity',
        component: () => import('@/app/sales_analysis/views/DatesGranularity'),
        name: 'datesGranularity',
        redirect: '/sales-analysis/dates-granularity/daily/',
        children: [
          {
            path: 'daily',
            name: 'datesGranularityDaily',
            component: () => import('@/app/sales_analysis/layouts/TheDailyLayout'),
            redirect: '/sales-analysis/dates-granularity/daily/weekly-aggregation',
            children: [
              {
                path: 'weekly-aggregation',
                name: 'datesGranularityDailyWeeklyAggregation',
                component: () => import('@/app/sales_analysis/components/TheWeeklyAggregation')
              },
              {
                path: 'extended',
                name: 'datesGranularityDailyExtended',
                component: () => import('@/app/sales_analysis/components/TheDailyExtended')
              }
            ]
          }
        ]
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/sales_analysis/Routes.js